import { Typography, Space, Breadcrumb } from 'antd';
import { tokens } from '../theme/theme';

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  description?: string;
  extra?: React.ReactNode;
  breadcrumb?: Array<{ title: string; href?: string }>;
}

export function PageHeader({ title, description, extra, breadcrumb }: PageHeaderProps) {
  return (
    <div
      style={{
        marginBottom: tokens.spacing.lg,
      }}
    >
      {breadcrumb && breadcrumb.length > 0 && (
        <Breadcrumb
          items={breadcrumb.map((item) => ({
            title: item.href ? <a href={item.href}>{item.title}</a> : item.title,
          }))}
          style={{ marginBottom: tokens.spacing.md }}
        />
      )}
      
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: tokens.spacing.base,
          flexWrap: 'wrap',
        }}
      >
        <Space orientation="vertical" size={4}>
          <Title
            level={2}
            style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 600,
              letterSpacing: '-0.5px',
            }}
          >
            {title}
          </Title>
          {description && (
            <Text type="secondary" style={{ fontSize: 15 }}>
              {description}
            </Text>
          )}
        </Space>
        
        {extra && <div>{extra}</div>}
      </div>
    </div>
  );
}

export default PageHeader;
